/**
 * TKP-67 — kütüphane amacı "işleme" mi "aktarım" mı olduğunu `kind` ile taşır. `null` = sınıflandırılmamış ve
 * bilinçli olarak iki listede birden görünür; birleşim kuralını backend uygular (`PurposeKind.ts`), arayüz yalnız
 * hangi listede olduğunu bildirir. Saf yardımcılar: store ve bileşenden bağımsız.
 */
export const PURPOSE_KIND = {
  PROCESSING: "PROCESSING",
  TRANSFERING: "TRANSFERING",
};

/** Ekranın hangi listeyi gösterdiği rota tanımından okunur (`meta.purposeKind`); yoksa süzgeç uygulanmaz. */
export const purposeKindOfRoute = (route) => {
  const kind = route && route.meta ? route.meta.purposeKind : undefined;
  return kind === PURPOSE_KIND.PROCESSING || kind === PURPOSE_KIND.TRANSFERING ? kind : undefined;
};

/** Aktarım bağlamı bayrağını türe çevirir (işleme/aktarım aynı formu paylaşıyor). */
export const purposeKindOfContext = (forTransfering) => (forTransfering ? PURPOSE_KIND.TRANSFERING : PURPOSE_KIND.PROCESSING);

/** Sayfalama sorgusuna eklenecek parça; tür yoksa boş nesne döner (sorgu genişlemez). */
export const purposeKindQuery = (kind) => (kind === PURPOSE_KIND.PROCESSING || kind === PURPOSE_KIND.TRANSFERING ? { kind: { value: kind, isObject: true } } : {});

/** Listedeki rozetin çeviri anahtarı; türsüz kayıt "sınıflandırılmamış" görünür. */
export const purposeKindLabelKey = (kind) => {
  if (kind === PURPOSE_KIND.PROCESSING) return "purpose.kind.processing";
  if (kind === PURPOSE_KIND.TRANSFERING) return "purpose.kind.transfering";
  return "purpose.kind.unclassified";
};

/** Başlık/boş durum metinleri liste türüne göre değişir. */
export const purposeListTitleKey = (kind) => {
  if (kind === PURPOSE_KIND.PROCESSING) return "processing.purpose.library";
  if (kind === PURPOSE_KIND.TRANSFERING) return "transfering.purpose.library";
  return "processing-transfering.purpose.library";
};
